import { Box, ContentBlock, Stack } from 'braid-design-system';

import { FeaturePromoBlock } from 'src/components/FeaturePromoBlock/FeaturePromoBlock';
import Image1 from 'src/images/products/Apply_with_SEEK-1.png';
import Image2 from 'src/images/products/Apply_with_SEEK-2.png';

import { SolutionsWrapper } from '../../components/SolutionsWrapper';

export const ApplyWithSeek = () => (
  <SolutionsWrapper page="Apply with SEEK">
    <ContentBlock>
      <Box paddingX={['gutter', 'none']} paddingY={['none', 'xlarge']}>
        <Stack space={['xlarge', 'xxlarge']} dividers="regular">
          <FeaturePromoBlock
            title="Give your candidates a better experience"
            text="Candidates can use their SEEK Profile and stored CV to pre-fill an application form on your careers website, helping you retrieve applications sooner."
            image={{
              url: Image1,
              height: 'tall',
            }}
          />
          <FeaturePromoBlock
            title="Allow applications across different devices"
            text="Let candidates complete applications across both mobile and desktop, so they can easily apply for your role anywhere, any time."
            image={{
              url: Image2,
              height: 'tall',
            }}
            reverse
          />
        </Stack>
      </Box>
    </ContentBlock>
  </SolutionsWrapper>
);
